/**
 * @generated SignedSource<<2907a1d7a90ffd607149a9434adaf261>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef$data = {
  readonly admin: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly projectStyle: JiraProjectStyle | null | undefined;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentType": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef";
};
export type issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef$key = {
  readonly " $data"?: issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_permissionsFragmentRef",
  "selections": [
    {
      "alias": "admin",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "EDIT_PROJECT_CONFIG"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ],
      "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    },
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "a379aab42f3391944eef1fd31015b8b1";

export default node;
